import { ActionType } from '../constants/ActionTypes';
import { Constants } from '../constants/Constants';
import { RestPath } from '../constants/SitePaths'
import config from '../constants/Configs';
import { message } from 'antd';
import axios from 'axios';

// Get All Users
export const getAllUsersBegin = () => ({
    type: ActionType.GET_ALL_USERS_BEGIN
});

export const getAllUsersSuccess = (data) => ({
    type: ActionType.GET_ALL_USERS_SUCCESS,
    payload: data
});

export const getAllUsersError = (data) => ({
    type: ActionType.GET_ALL_USERS_FAILURE,
    payload: data
});

// Get User
export const getUserBegin = () => ({
    type: ActionType.GET_USER_BEGIN
});

export const getUserSuccess = (data) => ({
    type: ActionType.GET_USER_SUCCESS,
    payload: data
});

export const getUserError = (data) => ({
    type: ActionType.GET_USER_FAILURE,
    payload: data
});

// Add User
export const addUserBegin = () => ({
    type: ActionType.ADD_USER_BEGIN
});

export const addNewUserSuccess = user => ({
    type: ActionType.ADD_USER_SUCCESS,
    payload: { user }
});

export const addUserError = (error) => ({
    type: ActionType.ADD_USER_FAILURE,
    payload: { error }
});


// Get User Types
export const getUserTypesBegin = () => ({
    type: ActionType.GET_USER_TYPES_BEGIN
});

export const getUserTypesSuccess = (data) => ({
    type: ActionType.GET_USER_TYPES_SUCCESS,
    payload: data
});

export const getUserTypesError = (data) => ({
    type: ActionType.GET_USER_TYPES_FAILURE,
    payload: data
});

// Get User Allowed Partners
export const getUserAllowedPartnersBegin = () => ({
    type: ActionType.GET_USER_ALLOWED_PARTNERS_BEGIN
});

export const getUserAllowedPartnersSuccess = (data) => ({
    type: ActionType.GET_USER_ALLOWED_PARTNERS_SUCCESS,
    payload: data
});

export const getUserAllowedPartnersError = (data) => ({
    type: ActionType.GET_USER_ALLOWED_PARTNERS_FAILURE,
    payload: data
});

// Edit User
export const editUserBegin = () => ({
    type: ActionType.EDIT_USER_BEGIN
});

export const editUserSuccess = (data) => ({
    type: ActionType.EDIT_USER_SUCCESS,
    payload: data
});

export const editUserError = (data) => ({
    type: ActionType.EDIT_USER_ERROR,
    payload: data
});

// Delete User
export const deleteUserBegin = () => ({
    type: ActionType.DELETE_USER_BEGIN
});

export const deleteUserSuccess = (data) => ({
    type: ActionType.DELETE_USER_SUCCESS,
    payload: data
});

export const deleteUserError = (data) => ({
    type: ActionType.DELETE_USER_ERROR,
    payload: data
});

/* Add User */
export function addUser(data, mainPartnerId, intl) {

    return dispatch => {
        dispatch(addUserBegin());

        const params = {
            ...data,
            mainPartnerId
        };

        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.ADD_USER,
            data: JSON.stringify(params),

        }).then((response) => {
            // Success
            dispatch(addNewUserSuccess(params));
            message.success(intl.messages.success_affiliate);
            return response.data;
        })
            .catch((error) => {
                dispatch(addUserError(error));
            });
    };
}

// Get All Users
export function getAllUsers(mainPartnerId, pageNumber, formData) {
    return dispatch => {
        dispatch(getAllUsersBegin());

        let params = formData ? {
            mainPartnerId,
            pageNumber,
            firstName: formData.firstName,
            lastName: formData.lastName,
            affiliateId: formData.affiliateId
        } : { mainPartnerId, pageNumber }


        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_ALL_USERS,
            params: params

        }).then((response) => {
            dispatch(getAllUsersSuccess(response.data));

            return response.data;
        })
            .catch((error) => {
                dispatch(getAllUsersError(error));
            });
    }
}

// Get Single Users Info
export function getUser(id) {
    return dispatch => {
        dispatch(getUserBegin());
        const params = `?id=${id}`;

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_USER + params
        }).then((response) => {
            dispatch(getUserSuccess(response.data));

            return response.data;
        })
            .catch((error) => {
                dispatch(getUserError(error));
            });
    }
}

export function getUserTypes() {
    return dispatch => {
        dispatch(getUserTypesBegin());

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_USER_TYPES,

        }).then((response) => {
            dispatch(getUserTypesSuccess(response.data));
            return response.data;
        })
            .catch((error) => {
                dispatch(getUserTypesError(error));
            });
    }
}

// Get main partners for add user
export function getUserAllowedPartners(userId) {
    return dispatch => {
        dispatch(getUserAllowedPartnersBegin());

        const params = `?userId=${userId}`;

        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_USER_ALLOWED_PARTNER + params,

        }).then((response) => {
            dispatch(getUserAllowedPartnersSuccess(response.data));

            return response.data;
        })
            .catch((error) => {
                dispatch(getUserAllowedPartnersError(error));
            });
    }
}

export function editUser(data, intl) {
    return dispatch => {
        dispatch(editUserBegin());

        let params = {
            ...data
        }

        return axios({
            method: Constants.PUT,
            url: config.BASE_URL + RestPath.EDIT_USER,
            data: JSON.stringify(params),

        }).then((response) => {
            dispatch(editUserSuccess(response.data));
            message.success(intl.messages.update_user);

            return response.data;
        })
            .catch((error) => {
                dispatch(editUserError(error));
            });
    }
}

export function deleteUser(id, intl) {
    return dispatch => {
        dispatch(deleteUserBegin());
        const params = `?id=${id}`;

        return axios({
            method: Constants.DELETE,
            url: config.BASE_URL + RestPath.DELETE_USER + params,

        }).then((response) => {
            dispatch(deleteUserSuccess(response.data));
            message.success(intl.messages.delete_user);
            return response.data;
        })
            .catch((error) => {
                dispatch(deleteUserError(error));
            });
    }
}


// WEBPACK FOOTER //
// ./src/actions/UsersActions.js